
<template>
  <div class="zUpload">
    <Upload
      ref="upload"
      :action="host"
      :headers="header"
      :data="data"
      :before-upload="handleBeforeUpload"
      :on-success="handleSuccess"
      :on-progress="handleProgress"
      :on-format-error="handleFormatError"
      :on-exceeded-size="handleMaxSize"
      :on-error="handleError"
      :format="format"
      :max-size="maxSize"
      :typemat="typemat"
      :show-upload-list="false"
      :type="drag?'drag':'select'"
      :multiple="multiple"
      :disabled="progress>0"
    >
      <div class="slot-con">
        <slot></slot>
        <Progress
          v-if="progressBar && progress > 0 && progress <= 100"
          :percent="progress"
          :stroke-width="10"
        />
      </div>
    </Upload>
  </div>
</template>
<script>
import { randomString } from "../../utils/assist.js";
import Cookie from "js-cookie";
import { setTimeout } from "timers";
const token = Cookie.get("ZHULOGIC_TOKEN");
export default {
  name: "ZUpload",
  props: {
    format: {
      type: Array,
      default() {
        return ["jpg", "jpeg", "png"];
      }
    },
    drag: {
      type: Boolean,
      default: true
    },
    // 是都可拖拽
    typemat: {
      type: String,
      default: "drag"
    },
    type: {
      type: Number,
      required: true
    },
    maxSize: {
      type: Number
    },
    multiple: {
      type: Boolean,
      default: false
    },
    ossKey: {
      type: Object,
      default: {}
    },
    progressBar: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      host: "",
      header: {
        Authorization: token
      },
      data: {
        "x:type": this.type,
        "x:originname": "",
        key: "",
        policy: "",
        OSSAccessKeyId: "",
        callback: "",
        signature: "",
        success_action_status: 200
      },
      progress: 0,
      beforeUploadParam: false,
      uploadImgLength: 0,
      filenameSuffix: "",
      originname: "",
      dir: "",
      isRefresh: 1,
      expire: ""
    };
  },
  methods: {
    handleSuccess(res) {
      this.progress = 0;
      if (res.message === "success") {
        this.$emit("success", res, this.uploadImgLength);
      } else {
        this.$Message.error("上传失败,请重新上传!");
        this.$emit("errUpload");
      }
      this.beforeUploadParam = false;
    },
    handleProgress(param) {
      this.progress = param.percent;
      this.$emit("progress", parseInt(param.percent));
    },
    handleFormatError() {
      this.beforeUploadParam = false;
      this.$Message.error("文件格式不匹配!");
      this.$emit("formatError");
    },
    handleMaxSize() {
      this.beforeUploadParam = false;
      this.$Message.error(`文件超出${Math.floor(this.maxSize/1000)}M大小限制!`);
      this.$emit("maxSizeError");
    },
    handleError() {
      this.beforeUploadParam = false;
      this.progress = 0;
      this.$Message.error("上传出错");
      this.$emit("uploadError");
    },
    handleBeforeUpload(file) {
      this.uploadImgLength = 0;
      this.beforeUploadParam = true;
      var timestamp = Date.parse(new Date());
      this.originname = file.name;
      let _ary = file.name.split(".");
      this.filenameSuffix = _ary[_ary.length-1];
      this.data.key = this.dir + randomString() + "." + this.filenameSuffix;
      Object.assign(this.data, { "x:originname": this.originname });
      if (!this.originname.match(/\.(jpg|jpeg|png|gif)$/)) {
        Object.assign(this.data, { 'Content-Disposition': `attachment;filename=${this.originname}` })
      }else{
        delete this.data['Content-Disposition']
      }
      this.$emit("beforeUpload", file);
    },
    refreshHandle() {
      this.$router.go(0);
    },
    liveHandle() {
      this.$router.go(-1);
    },
    getOssInfo() {
      if (this.ossKey && Object.keys(this.ossKey).length > 0) {
        this.expire = this.ossKey.expire;
        this.dir = this.ossKey.dir;
        this.data.policy = this.ossKey.policy;
        this.data.OSSAccessKeyId = this.ossKey.OSSAccessKeyId;
        this.data.callback = this.ossKey.callback;
        this.data.signature = this.ossKey.signature;
        this.host = this.ossKey.action;
      }
    }
  },
  watch: {
    beforeUploadParam: function() {
      if (this.beforeUploadParam) {
        this.uploadImgLength = this.$refs.upload.fileList.length;
      }
    }
  },
  created() {
    this.getOssInfo();
  },
  mounted() {}
};
</script>